"use client";

import { getOrCreateSignifydSessionId } from "@/lib/auth";
import Script from "next/script";

const SignifydScriptLoader = () => {
  const sessionId = getOrCreateSignifydSessionId();
  return (
    <Script
      defer
      type="text/javascript"
      id="sig-api"
      data-order-session-id={sessionId}
      src="https://cdn-scripts.signifyd.com/api/script-tag.js"
    />
  );
};
export default SignifydScriptLoader;
